import { api } from '../api';

export const grabPrize = (prizeId: string | number) => {
  return api.put<void>(`v1/wheel/prize/${prizeId}/grab`).then((res) => res.data);
};
